<template>
  <el-card class="box-card">
    <form-item
      :name="name"
      :label="getLabelText(base, name)"
      :hasDesc="hasDesc"
      :rules="rules"
      :descContent="getTransText(name,'desc',base)"
      >
    </form-item>
    <el-row
      v-for="(d, idx) in value"
      :key="idx"
      >
      <el-row v-if="!d.is_for_delete">
        <el-row :gutter="10">
          <el-date-picker
            type="daterange"
            v-model="d.times"
            :picker-options="pickerOptions"
            :clearable="false"
            @change="updateDates"
            >
          </el-date-picker>
        </el-row>
        <el-row :gutter="10" >
          <form-item
            name="action"
            :hasLabel="false"
            >
            <el-button
              type="primary"
              icon="el-icon-plus"
              @click="addRow(idx)"
              >
              {{ $t('api.actions.addDate.btn') }}
            </el-button>
            <el-button
              type="danger"
              icon="el-icon-minus"
              @click="minusRow(idx, d)"
              >
              {{ $t('api.actions.removeDate.btn') }}
            </el-button>
          </form-item>
        </el-row>
      </el-row>
    </el-row>
  </el-card>
</template>

<script>

import { getTransText, getLabelText } from '@/utils/i18n'
import _ from 'lodash'

const defData = {
  id: 0,
  times: [],
  is_for_delete: false
}

export default {
  name: 'multi-time-field',
  props: {
    value: {
      type: Array,
      default: () => [
        Object.assign({}, defData)
      ]
    },
    base: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      required: true
    },
    hasDesc: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      pickerOptions: {
        defaultTime: ['00:00:00', '23:59:59']
      }
    }
  },
  watch: {
    'value': {
      handler: function (v) {
        if (v) {
          if (this.isDeleted()) {
            this.value.push(Object.assign({}, defData))
          }
        }
      },
      deep: true
    }
  },
  computed: {
    rules () {
      return this.getRules(this.required)
    }
  },
  methods: {
    getTransText,
    getLabelText,
    isDeleted () {
      return _.every(this.value, i => {
        return i.is_for_delete === true
      })
    },
    getRules (v) {
      return (this.required) ? [{
        required: v,
        validator: this.validDate,
        message: this.getTransText(this.name, 'error', this.base),
        trigger: 'blur'
      }] : this.$attrs.rules
    },
    updateDates () {
      this.$emit('updateDates', this.value)
    },
    validDate (rule, value, callback) {
      let hasEmpty = _.some(this.value, i => {
        return i.times.length === 0
      })

      if (hasEmpty) {
        callback(new Error(this.getTransText(this.name, 'error', this.base)))
        return
      }

      callback()
    },
    addRow (idx) {
      this.$set(this.value, idx + 1, { ...defData })
      this.updateDates()
    },
    minusRow (idx, d) {
      if (d.id === 0) {
        this.value.splice(idx, 1)
      } else {
        this.value[idx].is_for_delete = true
      }

      this.updateDates()
    }
  }
}
</script>
